"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var svgson_1 = require("svgson");
var Parser = /** @class */ (function () {
    function Parser() {
    }
    Parser.parse = function (svg) {
        return typeof svg === 'string' ? svgson_1.parseSync(svg) : svg;
    };
    Parser.stringify = function (svg) {
        return typeof svg === 'string' ? svg : svgson_1.stringify(svg);
    };
    return Parser;
}());
exports.default = Parser;
//# sourceMappingURL=parser.js.map